module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', [(_vm.icon) ? _c('i', {
    class: _vm.icon
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(_vm.label))])]), _vm._v(" "), (_vm.noForm) ? _c('span', [(_vm.icon) ? _c('i', {
    class: _vm.icon
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3faf83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/CheckBox.vue
// module id = 1530
// module chunks = 0